// src/components/tracking/ScrollTracker.jsx

import { useEffect } from 'react';
import { trackEvent } from '../../utils/tracking/trackEvent';

export default function ScrollTracker({ pageName }) {
  useEffect(() => {
    const thresholds = [50, 100];
    const fired = new Set();

    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (window.scrollY / scrollHeight) * 100;

      thresholds.forEach(threshold => {
        if (scrolled >= threshold && !fired.has(threshold)) {
          trackEvent('scroll_depth', { page: pageName, depth: `${threshold}%` });
          fired.add(threshold);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pageName]);

  return null;
}